import classNames from 'classnames';

const Plus = ({ className = '' }) => (
  <svg
    data-testid="Plus"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('icon', className)}
  >
    <g fillRule="evenodd">
      <path
        fill="currentColor"
        d="M12.9999993,10.9999993 L18.9999997,10.9999993 C19.5522844,10.9999993 19.9999997,11.4477145 19.9999997,11.9999993 C19.9999997,12.552284 19.5522844,12.9999993 18.9999997,12.9999993 L12.9999993,12.9999993 L12.9999993,18.9999997 C12.9999993,19.5522844 12.552284,19.9999997 11.9999993,19.9999997 C11.4477145,19.9999997 10.9999993,19.5522844 10.9999993,18.9999997 L10.9999993,12.9999993 L4.9999997,12.9999993 C4.44771495,12.9999993 3.9999997,12.552284 3.9999997,11.9999993 C3.9999997,11.4477145 4.44771495,10.9999993 4.9999997,10.9999993 L10.9999993,10.9999993 L10.9999993,4.9999997 C10.9999993,4.44771495 11.4477145,3.9999997 11.9999993,3.9999997 C12.552284,3.9999997 12.9999993,4.44771495 12.9999993,4.9999997 L12.9999993,10.9999993 Z"
      />
    </g>
  </svg>
);

Plus.propTypes = {
  className: PropTypes.string,
};

export default Plus;
